import ConsolidatedSupplyDrawer from '../supply-orders/components/ConsolidatedSupplyDrawer';
import { Box } from '@mui/material';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { FormTitleBox, TableBodySkeleton } from '../../common/components';
import InternalOrdersDataTable from './components/InternalOrdersDataTable';
import InternalOrdersFilters from './components/InternalOrdersFilters';
import InternalOrdersPagination from './components/InternalOrdersPagination';
import InternalOrdersSelectionToolbar from './components/InternalOrdersSelectionToolbar';
import InternalOrderDialog from './components/InternalOrderDialog';
import InternalOrderDetailDialog from './components/InternalOrderDetailDialog';
import { useInternalOrdersTable } from './hooks/useInternalOrdersTable';
import { usePermissions } from '../../hooks/usePermissions';

const InternalOrdersTable = () => {
  const { permissions } = usePermissions();
  const {
    consolidation,
    operationalDestinations,
    orderFilterOptions,
    expandedId,
    expandedQuery,
    onExpand,
    sort,
    onSort,
    groupOptions,
    groupSearch,
    setGroupSearch,
    changeGroups,
    scopeOptions,
    data,
    isLoading,
    isSaving,
    isProcessing,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    searchTerm,
    filters,
    dialogOpen,
    detailDialogOpen,
    selectedOrder,
    selectedOrderDetail,
    detailOrderLoading,
    warehouses,
    projects,
    projectsLoading,
    warehousesLoading,
    handleSearch,
    handleFilterChange,
    handlePageChange,
    handleRowsPerPageChange,
    handleOpenDialog,
    handleCloseDialog,
    handleInputChange,
    handleSelectChange,
    handleAddMaterial,
    handleUpdateMaterialQuantity,
    handleRemoveMaterial,
    handleSave,
    handleViewDetail,
    handleCloseDetailDialog,
    handleAuthorizeOrder,
    handleCheckStock,
    handleSetConsumptionAuthorization,
    handleRefreshDetailOrder,
    handleCancelOrder,
  } = useInternalOrdersTable();

  return (
    <Box>
      <FormTitleBox
        title="Stock y Compras | Pedidos técnicos"
        showButton={permissions.canCreateInternalOrders}
        buttonText="Nuevo pedido"
        buttonIcon={AddShoppingCartIcon}
        onButtonClick={handleOpenDialog}
        showSearch={true}
        searchLabel="Buscar pedido"
        searchValue={searchTerm}
        onSearchChange={handleSearch}
        searchSize="medium"
        isLoading={isSaving || isProcessing}
      />

      <InternalOrdersFilters
        filters={filters}
        warehouses={warehouses}
        projects={projects}
        onFilterChange={handleFilterChange}
        onSelectChange={handleFilterChange}
        orderFilterOptions={orderFilterOptions}
        scopeOptions={scopeOptions}
      />

      {permissions.canCreateSupplyOrderDraftFromExternalOrder && (
        <InternalOrdersSelectionToolbar
          count={consolidation.selected.length}
          onGenerate={consolidation.show}
          onClear={consolidation.clear}
        />
      )}
      <ConsolidatedSupplyDrawer {...consolidation.drawerProps} />

      <InternalOrdersDataTable
        expandedId={expandedId}
        expandedQuery={expandedQuery}
        onExpand={onExpand}
        data={data}
        selectedIds={consolidation.selected}
        onToggleSelection={
          permissions.canCreateSupplyOrderDraftFromExternalOrder ? consolidation.toggle : undefined
        }
        onTogglePage={() => consolidation.togglePage(data)}
        canSelect={consolidation.canSelect}
        isLoading={isLoading}
        actionsDisabled={isSaving || isProcessing}
        onView={handleViewDetail}
        sort={sort}
        onSort={onSort}
        LoadingComponent={TableBodySkeleton}
      />

      {totalPages > 1 && (
        <InternalOrdersPagination
          totalPages={totalPages}
          totalCount={totalCount}
          page={page}
          onPageChange={handlePageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      )}

      <InternalOrderDialog
        groupOptions={groupOptions}
        operationalDestinations={operationalDestinations}
        groupSearch={groupSearch}
        setGroupSearch={setGroupSearch}
        changeGroups={changeGroups}
        open={dialogOpen}
        onClose={handleCloseDialog}
        selectedOrder={selectedOrder}
        onInputChange={handleInputChange}
        onSelectChange={handleSelectChange}
        onSave={handleSave}
        warehouses={warehouses}
        warehousesLoading={warehousesLoading}
        projects={projects}
        projectsLoading={projectsLoading}
        searchEnabled={dialogOpen}
        onAddMaterial={handleAddMaterial}
        onUpdateMaterialQuantity={handleUpdateMaterialQuantity}
        onRemoveMaterial={handleRemoveMaterial}
        isSaving={isSaving}
      />

      <InternalOrderDetailDialog
        open={detailDialogOpen}
        onClose={handleCloseDetailDialog}
        order={selectedOrderDetail}
        onAuthorizeOrder={handleAuthorizeOrder}
        onCheckStock={handleCheckStock}
        onSetConsumptionAuthorization={handleSetConsumptionAuthorization}
        onCancelOrder={handleCancelOrder}
        onOrderUpdated={handleRefreshDetailOrder}
        isProcessing={isProcessing}
        isLoading={detailOrderLoading}
      />
    </Box>
  );
};

export default InternalOrdersTable;
